export const PRODUCT_BUILDER_LABELS = {
  itemAvailableTitle: "Available",
  itemAvailableHint: "Customers can add this item to cart.",
  requiresPrebookingTitle: "Requires prebooking",
  requiresPrebookingHint: "Customers must select a date and slot before checkout.",
  requiresPrebookingDisabledHint: "Add availability slots in Settings step to enable prebooking.",
  maxFilesLabel: "Max files",
  maxFilesHint: "Customers can upload 1–5 files for this customisation.",
  calculatePricePerFileLabel: "Price per file",
  calculatePricePerFileHint: "Multiply customisation price by the number of uploaded files.",
  selectionTypeLabel: "Selection",
  selectionTypeHint: "Single choice: customer picks one option (e.g. Size — S/M/L). Multiple choice: customer can pick several options at once (e.g. Toppings — cheese, olives, mushrooms).",
  customisationTypeLabel: "Type",
  customisationTypeHint: "Yes / No: simple on/off add-on. Text: free-text note from the customer. File upload: customer uploads files (e.g. print artwork). Dropdown: customer picks one choice from a list you define.",
  videoUrlsLabel: "Video URLs (optional)",
  videoUrlsHint: "YouTube links are best rendered on the storefront. Instagram links are supported but open and play in an external window.",
  videoUrlsHelp: "Add YouTube, Instagram or other video URLs (max 3)",
  variantsSectionHint: "Variants let customers choose required product options that change the item (size, colour, weight). Each option can adjust price.",
  customisationsSectionHint: "Customisations are optional extras the customer can add (gift wrap, engraving, file upload). They sit on top of the base item and variants.",
  editCustomisationTooltip: "Edit customisation",
  deleteCustomisationTooltip: "Delete customisation",
  editVariantTooltip: "Edit variant",
  deleteVariantTooltip: "Delete variant",
};
